import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import { RootState } from "core-integration/src/store";
import { getCupMatchesByLeagueId } from "core-integration/src/store/entries/reducers";
import {
  CupMatchesByLeagueId,
  ILeagueEntry,
} from "core-integration/src/store/entries/types";
import { VisuallyHidden } from "../Utils";
import CupTypeRow from "./CupTypeRow";
import {
  LeagueSummaryHeading,
  LeagueSummaryTable,
  SummaryCupCol,
  SummaryRoundCol,
  SummaryStatusCol,
} from "./Styles";

interface IProps {
  entryId: number;
  leagues: ILeagueEntry[];
  title: string;
}

const MyLeagueCupSummary: React.FC<IProps> = ({ entryId, leagues, title }) => {
  const cupMatches: CupMatchesByLeagueId | null = useSelector(
    (state: RootState) =>
      entryId ? getCupMatchesByLeagueId(state, entryId) : null,
  );
  const { t } = useTranslation();

  return (
    <Box pb={4}>
      <LeagueSummaryHeading>{title}</LeagueSummaryHeading>
      <LeagueSummaryTable>
        <thead>
          <tr>
            <SummaryCupCol scope="col">
              <VisuallyHidden>
                {t("myLeagueCupSummary.cup", "Cup")}
              </VisuallyHidden>
            </SummaryCupCol>
            <SummaryRoundCol scope="col">
              <VisuallyHidden>
                {t("myLeagueCupSummary.round", "Round")}
              </VisuallyHidden>
            </SummaryRoundCol>
            <SummaryStatusCol scope="col">
              <VisuallyHidden>
                {t("myLeagueCupSummary.status", "Status")}
              </VisuallyHidden>
            </SummaryStatusCol>
          </tr>
        </thead>
        <tbody>
          {leagues.map((l) => (
            <CupTypeRow
              key={l.id}
              cupMatch={
                cupMatches && l.cup_league ? cupMatches[l.cup_league] : null
              }
              entryId={entryId}
              league={l}
            />
          ))}
        </tbody>
      </LeagueSummaryTable>
    </Box>
  );
};

export default MyLeagueCupSummary;
